import request from '@/utils/request'
import store from '@/store'
// 获取当前登录用户的 adminId
function getAdminId() {
  return store.state.userInfo?.id || store.state.userInfo?.adminId || JSON.parse(localStorage.getItem('userInfo') || '{}').id
}
// 生成兑换码
export function generateCodes(data) {
  return request({
    url: '/codes/generate',
    method: 'post',
    
        data: {
      ...data,
      adminId: getAdminId()
    }
  })
}

// // 获取兑换码列表
// export function getCodeList(data) {
//   return request({
//     url: '/wineQrCode/list',
//     method: 'get',
//     params: {
//       ...data,
//       adminId: getAdminId()
//     }
//   })
// }

// 获取兑换码列表
export function getCodeList(data) {
  return request({
    url: '/codes/list',
    method: 'get',
    params: {
      ...data,
      adminId: getAdminId()
    }
  })
}
// 删除兑换码
export function deleteCodes(data) {
  return request({
    url: '/codes/delete',
    method: 'delete',
    data
  })
}

// 验证兑换码
export function verifyCode(data) {
  return request({
    url: '/spin/verifyCode',
    method: 'post',
    data
  })
}

// 导出兑换码
export function exportCodes(data) {
  return request({
    url: '/codes/export',
    method: 'get',
    params: {
      ...data,
      adminId: getAdminId()
    },
    responseType: 'blob' // 重要：设置响应类型为 blob
  })
}
